'use strict';

const SELECTOR = '.donation-panel';

export function init() {
    document.querySelectorAll(SELECTOR).forEach(element => {
        element.addEventListener('submit', event => {
            event.preventDefault();

            const cid = event.target.dataset.contribution;
            let amount = event.target.amount.value;

            // const ct = event.target.ct.value;

            if(!cid) {
                return;
            }

            if (!amount) {
                return alert('Please select a donation amount');
            }

            // const url = new URL(event.target.action);
            // // url.searchParams.set('amount', amount);
            // // url.searchParams.set('ct', ct);

            window.location.href = `${event.target.action}${cid}/add-to-basket/${amount}`;
        });
    });
}
